module.exports = __webpack_public_path__ + "static/media/crown-premium-products.cd8f2dca.png";


//////////////////
// WEBPACK FOOTER
// ./src/newDropshipperApp/images/crown-premium-products.png
// module id = 738
// module chunks = 0